(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('chatPresenceService', ['$http', '$q', 'portalConfig', 'jwtService',
            function ($http, $q, portalConfig, jwtService) {


                var _presence = "offline";
                var urlBase = portalConfig.urlBase;
                //  urlBase = "http://localhost:8001";

                var fac = {
                    getMyPresence: getMyPresence,
                    getPlatformUserPresence: getPlatformUserPresence,
                    getPresence: getPresence,
                    getPresences: getPresences,
                    changePresenceToAway: changePresenceToAway,
                    changePresenceToBack: changePresenceToBack,
                };

                return fac;


                /**
                 */

                function getMyPresence() {
                    return _presence;
                }

                /**
                 */


                function setPresence(response) {

                    if (response[0] && response[0].profileId) {
                        var requestedProfileId = response[0].profileId.split('\\');

                        if (requestedProfileId[0] === 'PLATFORMUSER' && requestedProfileId.length === 2) {
                            requestedProfileId = requestedProfileId[1];
                        }
                        else if (requestedProfileId.length === 1) {
                            requestedProfileId = requestedProfileId[0];
                        }
                        else {
                            requestedProfileId = requestedProfileId.join('\\');
                        }

                        if (requestedProfileId == jwtService.payload.sub) {
                            _presence = (jwtService.payload.isImpersonating || response[0].isAway) ? "offline" : "available";
                        }
                    }
                }

                /**
                 */

                function getPlatformUserPresence(apiSpaceId, profileId) {
                    profileId = encodeURIComponent('PLATFORMUSER\\' + profileId);

                    return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/presence?id=" + profileId)
                        .then(getPresenceComplete)
                        .catch(getPresenceFailed);

                    function getPresenceComplete(response) {
                        setPresence(response.data);
                        return response.data;
                    }

                    function getPresenceFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                /**
                 * get Presence
                 * @param {string} apiSpaceId 
                 * @param {string} profileId
                 */
                function getPresence(apiSpaceId, profileId) {
                    profileId = encodeURIComponent(profileId);
                    return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/presence?id=" + profileId)
                        .then(getPresenceComplete)
                        .catch(getPresenceFailed);

                    function getPresenceComplete(response) {
                        setPresence(response.data);
                        return response.data;
                    }

                    function getPresenceFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }


                /**
                 * get Presence
                 * @param {string} apiSpaceId 
                 * @param {string[]} profileIds
                 */
                function getPresences(apiSpaceId, profileIds) {

                    var query = "";
                    angular.forEach(profileIds, function (profileId) {
                        query += ("id=" + profileId + "&");
                    });

                    return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/presence?" + query)
                        .then(getPresencesComplete)
                        .catch(getPresencesFailed);

                    function getPresencesComplete(response) {
                        return response.data;
                    }

                    function getPresencesFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }


                /**
                 * change Presence To Away
                 * @param {*} apiSpaceId 
                 */
                function changePresenceToAway(apiSpaceId) {

                    return $http.post(urlBase + "/apispaces/" + apiSpaceId + "/presence/away")
                        .then(changePresenceToAwayComplete)
                        .catch(changePresenceToAwayFailed);

                    function changePresenceToAwayComplete(response) {
                        _presence = "away";
                        return response.data;
                    }

                    function changePresenceToAwayFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }
                /**
                 * change Presence To Back
                 * @param {*} apiSpaceId 
                 */
                function changePresenceToBack(apiSpaceId) {

                    return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/presence/away")
                        .then(changePresenceToBackComplete)
                        .catch(changePresenceToBackFailed);

                    function changePresenceToBackComplete(response) {
                        _presence = "available";
                        return response.data;
                    }

                    function changePresenceToBackFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }
            }]);

})(window.angular);